import React from "react";

const TabComponent = ({ tabs, selectedTab, onSelectTab }) => {
  return (
    <div className="w-full h-[34px] flex items-center space-x-2">
      {tabs.map((tab, index) => (
        <div
          key={index}
          onClick={() => onSelectTab(index)}
          className={`flex items-center shadow-md rounded-full px-3 py-1 [font-family:'Inter-Regular',Helvetica] tracking-[0] text-lg font-normal whitespace-nowrap cursor-pointer ${
            selectedTab === index
              ? "bg-[#e17954]  text-white"
              : "bg-white text-[#1d2951]"
          }`}
          style={{ fontSize: '15px' }}
        >
          {tab.label}
         

        </div>
      ))}
    </div>
  );
};

export default TabComponent;
